"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCetEvents = exports.default = void 0;
var _react = require("react");
var _useScripts = require("./useScripts");
var _urls = require("../utilities/urls");
var _useSessionData = require("./useSessionData");
var _CetComponentsProvider = require("../providers/CetComponentsProvider");
const useScriptsList = {
  scriptsList: [{
    src: `${_urls.apiGatewayUrl}/bigdataapi/provider/BigDataProvider.js`,
    isWaitUntilLoaded: false,
    checkIfAlreadyLoaded: () => window.cet && window.cet.microservices && window.cet.microservices.bigData
  }]
};
const useCetEvents = () => {
  const {
    siteKey,
    language
  } = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext);
  const {
    isReady,
    error
  } = (0, _useScripts.useScripts)(useScriptsList);
  const {
    isSessionDataReady,
    sessionId,
    userId,
    role,
    schoolId
  } = (0, _useSessionData.useSessionData)();
  const unsentEventsQueue = (0, _react.useRef)([]);
  const GUEST_ID = '00000000-0000-0000-0000-000000000000';
  const GUEST = 'guest';
  (0, _react.useEffect)(() => {
    if (isSessionDataReady && isReady && unsentEventsQueue.current?.length > 0) {
      unsentEventsQueue.current.forEach(eventSenderFunc => {
        eventSenderFunc?.();
      });
      unsentEventsQueue.current = [];
    }
  }, [isSessionDataReady, isReady, unsentEventsQueue]);
  const getOptionalParams = (0, _react.useCallback)((optionalData, lang, eventData) => {
    let optionalParams = {
      currentHyperlink: eventData.currentHyperlink,
      schoolId: schoolId,
      sessionId: sessionId,
      contentLanguage: lang,
      objectAdditionalInformation: {}
    };
    optionalParams = {
      ...optionalParams,
      ...optionalData
    };
    optionalParams.objectAdditionalInformation = optionalData.objectAdditionalInformation || {};
    return optionalParams;
  }, [schoolId, sessionId]);
  const sendEvent = (0, _react.useCallback)(func => {
    if (isSessionDataReady) {
      if (useScriptsList.scriptsList[0].checkIfAlreadyLoaded?.()) {
        func();
      } else {
        if (error) {
          console.error('Error while trying to send event', error);
        } else {
          unsentEventsQueue.current.push(func);
        }
      }
    }
  }, [isSessionDataReady, error, unsentEventsQueue]);
  const sendUiUsageEvent = (0, _react.useCallback)(data => {
    if (!data.contextReferrer) {
      data.contextReferrer = window.contextReferrer ?? window.location.href;
    }
    if (!data.currentHyperlink) {
      data.currentHyperlink = window.currentHyperlink ?? window.location.href;
    }
    sendEvent(() => {
      const requestData = {
        verb: data.verb || 'pressed',
        category: data.category,
        label: data.label,
        contextReferrer: data.contextReferrer,
        optionalData: data.optionalData || {}
      };
      const uiUsageObjectName = requestData.label;
      const uiUsageObjectId = siteKey + '~' + requestData.category + '~' + requestData.label;
      const uiUsageObjectType = 'inputControl';
      const optionalParams = getOptionalParams(requestData.optionalData, language, data);
      try {
        window.cet.microservices.bigData.messages.sendUiUsageEvent(window.cet.microservices.bigData.enums.verbs[requestData.verb], uiUsageObjectId, uiUsageObjectName, window.cet.microservices.bigData.enums.objectTypes[uiUsageObjectType], siteKey, requestData.contextReferrer, role || GUEST, userId || GUEST_ID, optionalParams);
      } catch (ex) {
        console.error(ex);
      }
    });
  }, [getOptionalParams, language, role, sendEvent, siteKey, userId]);
  const sendLearningEvent = (0, _react.useCallback)(data => {
    if (!data.contextReferrer) {
      data.contextReferrer = window.contextReferrer ?? window.location.href;
    }
    if (!data.currentHyperlink) {
      data.currentHyperlink = window.currentHyperlink ?? window.location.href;
    }
    sendEvent(() => {
      const requestData = {
        verbType: data.verbType,
        objectId: data.objectId,
        objectName: data.objectName,
        objectType: data.objectType || 'webpage',
        contextReferrer: data.contextReferrer,
        optionalData: data.optionalData ?? {}
      };
      const optionalParams = getOptionalParams(requestData.optionalData, language, data);
      try {
        window.cet.microservices.bigData.messages.sendLearningEvent(window.cet.microservices.bigData.enums.verbs[requestData.verbType], requestData.objectId, requestData.objectName, window.cet.microservices.bigData.enums.objectTypes[requestData.objectType], siteKey, requestData.contextReferrer, role ?? GUEST, userId ?? GUEST_ID, optionalParams);
      } catch (ex) {
        console.error(ex);
      }
    });
  }, [getOptionalParams, language, role, sendEvent, siteKey, userId]);
  return {
    sendUiUsageEvent,
    sendLearningEvent
  };
};
exports.useCetEvents = useCetEvents;
var _default = exports.default = useCetEvents;